function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M16.333 16l-1 1h-2v-2l1-1 2 2zM11.333 15h-6v2h6v-2z",
  fill: "#A7AEB7"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1.333 3v18h14v-2h-12V5h6v4h6l-6-6h-8z",
  fill: "#F2F5F9"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M11.333 13v-2h-6v2h6zM21.333 7l-6 6 2 2 6-6-2-2z",
  fill: "#F2F5F9"
});

var SvgEngageInProposals = function SvgEngageInProposals(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _ref, _ref2, _ref3);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE2LjMzMzMgMTZMMTUuMzMzMyAxN0gxMy4zMzMzVjE1TDE0LjMzMzMgMTRMMTYuMzMzMyAxNloiIGZpbGw9IiNBN0FFQjciLz4KPHBhdGggZD0iTTExLjMzMzMgMTVINS4zMzMzMVYxN0gxMS4zMzMzVjE1WiIgZmlsbD0iI0E3QUVCNyIvPgo8cGF0aCBkPSJNMS4zMzMzMSAzVjIxSDE1LjMzMzNWMTlIMy4zMzMzMVY1SDkuMzMzMzFWOUgxNS4zMzMzTDkuMzMzMzEgM0gxLjMzMzMxWiIgZmlsbD0iI0YyRjVGOSIvPgo8cGF0aCBkPSJNMTEuMzMzMyAxM1YxMUg1LjMzMzMxVjEzSDExLjMzMzNaIiBmaWxsPSIjRjJGNUY5Ii8+CjxwYXRoIGQ9Ik0yMS4zMzMzIDdMMTUuMzMzMyAxM0wxNy4zMzMzIDE1TDIzLjMzMzMgOUwyMS4zMzMzIDdaIiBmaWxsPSIjRjJGNUY5Ii8+Cjwvc3ZnPgo=";
export { SvgEngageInProposals as ReactComponent };